"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Dashboard_exports = {};
__export(Dashboard_exports, {
  default: () => Dashboard_default
});
module.exports = __toCommonJS(Dashboard_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.83984 11.0898H8.83984C9.0612 11.0898 9.25 11.0117 9.40625 10.8555C9.57552 10.6862 9.66016 10.4844 9.66016 10.25V3.58984C9.66016 3.35547 9.57552 3.16016 9.40625 3.00391C9.25 2.83464 9.0612 2.75 8.83984 2.75H3.83984C3.60547 2.75 3.40365 2.83464 3.23438 3.00391C3.07812 3.16016 3 3.35547 3 3.58984V10.25C3 10.4844 3.07812 10.6862 3.23438 10.8555C3.40365 11.0117 3.60547 11.0898 3.83984 11.0898ZM3.83984 17.75H8.83984C9.0612 17.75 9.25 17.6719 9.40625 17.5156C9.57552 17.3464 9.66016 17.1445 9.66016 16.9102V13.5898C9.66016 13.3555 9.57552 13.1602 9.40625 13.0039C9.25 12.8346 9.0612 12.75 8.83984 12.75H3.83984C3.60547 12.75 3.40365 12.8346 3.23438 13.0039C3.07812 13.1602 3 13.3555 3 13.5898V16.9102C3 17.1445 3.07812 17.3464 3.23438 17.5156C3.40365 17.6719 3.60547 17.75 3.83984 17.75ZM12.1602 17.75H17.1602C17.3945 17.75 17.5898 17.6719 17.7461 17.5156C17.9154 17.3464 18 17.1445 18 16.9102V10.25C18 10.0156 17.9154 9.82031 17.7461 9.66406C17.5898 9.49479 17.3945 9.41016 17.1602 9.41016H12.1602C11.9388 9.41016 11.7435 9.49479 11.5742 9.66406C11.418 9.82031 11.3398 10.0156 11.3398 10.25V16.9102C11.3398 17.1445 11.418 17.3464 11.5742 17.5156C11.7435 17.6719 11.9388 17.75 12.1602 17.75ZM11.3398 3.58984V6.91016C11.3398 7.14453 11.418 7.34635 11.5742 7.51562C11.7435 7.67188 11.9388 7.75 12.1602 7.75H17.1602C17.3945 7.75 17.5898 7.67188 17.7461 7.51562C17.9154 7.34635 18 7.14453 18 6.91016V3.58984C18 3.35547 17.9154 3.16016 17.7461 3.00391C17.5898 2.83464 17.3945 2.75 17.1602 2.75H12.1602C11.9388 2.75 11.7435 2.83464 11.5742 3.00391C11.418 3.16016 11.3398 3.35547 11.3398 3.58984Z",
      fill: "currentColor"
    }
  )
);
const SvgDashboard = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Dashboard_default = SvgDashboard;
